import React from "react"
import ReactDOM from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import "./styles/globals.css"
import { AppShell } from "@/components/AppShell"
import { AuthGate } from "@/components/AuthGate"
import { Catalog } from "@/pages/Catalog"
import { VideoPage } from "@/pages/Video"
import { RequestAccess } from "@/pages/RequestAccess"
import { AdminDashboard } from "@/pages/admin/Dashboard"
import { AdminVideos } from "@/pages/admin/Videos"
import { AdminUsers } from "@/pages/admin/Users"
import { AdminTags } from "@/pages/admin/Tags"
import { AdminRequests } from "@/pages/admin/Requests"

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<AuthGate><Catalog /></AuthGate>} />
            <Route path="/v/:slug" element={<AuthGate><VideoPage /></AuthGate>} />
            <Route path="/request-access" element={<AuthGate><RequestAccess /></AuthGate>} />
            <Route path="/admin" element={<AuthGate requireAdmin><AdminDashboard /></AuthGate>} />
            <Route path="/admin/videos" element={<AuthGate requireAdmin><AdminVideos /></AuthGate>} />
            <Route path="/admin/users" element={<AuthGate requireAdmin><AdminUsers /></AuthGate>} />
            <Route path="/admin/tags" element={<AuthGate requireAdmin><AdminTags /></AuthGate>} />
            <Route path="/admin/requests" element={<AuthGate requireAdmin><AdminRequests /></AuthGate>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
